const getBuildTime = () => {
  return (new Date()).toISOString();
};

const copyrightYear = new Date().getFullYear();


const getPageUrl = (siteUrl, location) => {
  return `${siteUrl}${location?.pathname}`;
};

const toWebPageJsonLd = (args) => {
  const {title, description, canonical, siteUrl, language, publishedAt, location,  defaultLogoUrl,
    isScPoWebsite} = args;
  const jsonLdObject = {
    '@context': 'http://schema.org',
    '@type': 'WebPage',
    'url': getPageUrl(siteUrl, location),
    'mainEntityOfPage': canonical,
    'name': title,
    'inLanguage': language,
    'description': description,
    'copyrightYear': copyrightYear,
    'datePublished': publishedAt,
    'dateModified': getBuildTime()
  };
  if (isScPoWebsite) {
    jsonLdObject['publisher'] = {
      '@type': 'Organization',
      'name': 'Sciences Po',
      'url': 'https://www.sciencespo.fr',
      'logo': {
        '@type': "ImageObject",
        'url': defaultLogoUrl,
        "width": 300,
        "height": 60
      }
    }
  }
  return JSON.stringify(jsonLdObject, null, 2);
};


const toNewsJsonLd = (args) => {
  const { publishedAt: publicationDate, title, description,
    canonical, coverImageUrl, defaultLogoUrl,
    isScPoWebsite,
    author, language} = args;

  const jsonLdObject = {
    '@context': 'https://schema.org',
    '@type': 'NewsArticle',
    'mainEntityOfPage': {
      '@type': 'WebPage',
      '@id': canonical
    },
    'inLanguage': language,
    'name': title,
    'headline': title,
    'datePublished': publicationDate,
    'dateModified': publicationDate,
    'description': description
  };
  if (isScPoWebsite) {
    jsonLdObject['publisher'] = {
      '@type': 'Organization',
      'name': 'Sciences Po',
      'url': 'https://www.sciencespo.fr',
      'logo': {
        '@type': "ImageObject",
        'url': defaultLogoUrl,
        "width": 300,
        "height": 60
      }
    }
  }
  if (coverImageUrl) {
    jsonLdObject['image'] = [
      {
        '@type':'ImageObject',
        'url' : coverImageUrl
      }]
  }
  if (author) {
    jsonLdObject['author'] = {
      '@type': 'Person',
      'name': author
    };
  }
  return JSON.stringify(jsonLdObject, null, 2);
};


const getEvtAddress = (street, city, zip, country) => {
  const o = {
    streetAddress: street,
    addressLocality: city,
    postalCode: zip,
    country: country
  };

  // Remove properties with null, undefined, or empty string values
  const filtered = Object.fromEntries(
    Object.entries(o).filter(([_, v]) => v != null && v !== '')
  );

  // If no fields are left, return null
  const address = Object.keys(filtered).length > 0 ? filtered : null;
  if (address) {
    return {
      'address' : {
        '@type': 'PostalAddress',
        ...address
      }
    };
  }
  return null;
};


const toEventJsonLd = (args) => {
  const {
    title: name, uri, description,
    start_date: startDate,
    end_date: endDate, eventLocation,
    coverImageUrl,
    eventLive
  } = args;
  const {room, event_address} = (eventLocation || {});
  const {city, zip, country, address: street} = (event_address || {});


  let location = null;
  const address = getEvtAddress(street, city, zip, country);
  if( address || (room && room.trim() !=='')) {
    location = {
      '@type' : 'Place'
    };
    if (room) {
      location['name'] = room;
    }
    if (address) {
      location['address'] = address;
    }
  }


  const jsonLdObject = {
    '@context': 'https://schema.org',
    '@type': 'Event',
    'name': name,
    'eventStatus': 'https://schema.org/EventScheduled',
    'organizer': {
      '@type': 'Organization',
      'name': 'Sciences Po',
      'url': 'https://www.sciencespo.fr'
    }
  };
  if (eventLive) {
    jsonLdObject['eventAttendanceMode'] = 'https://schema.org/OnlineEventAttendanceMode';
  } else {
    jsonLdObject['eventAttendanceMode'] = 'https://schema.org/OfflineEventAttendanceMode';
  }
  if (uri) {
    jsonLdObject['url'] = uri;
  }
  if (coverImageUrl) {
    jsonLdObject['image'] = [{
        '@type':'ImageObject',
        'url' : coverImageUrl
      }];
  }
  if (startDate) {
    jsonLdObject['startDate'] = startDate;
  }
  if (endDate) {
    jsonLdObject['endDate'] = endDate;
  }
  if (description && description.trim() !=='') {
    jsonLdObject['description'] = description;
  }
  if (location) {
    jsonLdObject['location'] = location;
  }
  return JSON.stringify(jsonLdObject, null, 2);
};

const toPerson = (args) => {
  const jsonLdObject = {
    '@context': 'https://schema.org',
    '@type': 'Person',
    'name': args.title
  };
  return JSON.stringify(jsonLdObject, null, 2);
};


const toExEDProduct = (args) => {
  const jsonLdObject = {
    '@context': 'https://schema.org',
    '@type': 'Course',
    'name': args.title,
    'description': args.description,
    'provider': {
      '@type': 'Organization',
      'name':  'Sciences Po - Executive Education',
      'sameAs': 'https://www.sciencespo.fr/executive-education',
      'parentOrganization': {
        '@type': 'Organization',
        'name': 'Sciences Po',
        'sameAs': 'https://www.sciencespo.fr/'
      }
    }
  };
  return JSON.stringify(jsonLdObject, null, 2);
};


const toLdJson = (args) => {
  const {type} = args;
  if (type === 'Event') {
    return toEventJsonLd (args);
  } else if (type === 'News') {
    return toNewsJsonLd (args);
  } else if (type === 'InternalPage') {
    return toWebPageJsonLd (args);
  } else if (type === 'ExEDProduct'){
    return toExEDProduct(args);
  } else if (type === 'People') {
    return toPerson(args);
  }
  return null;
};

module.exports = {
  toLdJson,
  toEventJsonLd,
  toWebPageJsonLd,
  toNewsJsonLd
};